import { useEffect, useRef, useState, memo } from 'react';
import PubSub from 'pubsub-js';
import Link from 'next/link';
import Router from 'next/router';

import { connect } from 'react-redux';
import actions from '../redux/actions';

import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import StarHalfIcon from '@material-ui/icons/StarHalf';
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

function DisparoShell(props) {
  const { isAuthenticated, user } = props;

  // refs p/ componentes pesados (lazy)
  const ResponsiveDrawerRef = useRef(null);
  const DrawerComparacaoRef = useRef(null);

  // estados de abertura
  const [openResponsiveDrawer, setOpenResponsiveDrawer] = useState(false);
  const [openDrawerComparacao, setOpenDrawerComparacao] = useState(false);

  // carrega o ResponsiveDrawer sob demanda
  async function ensureResponsiveDrawerLoaded() {
    if (!ResponsiveDrawerRef.current) {
      const mod = await import('./disparoResponsive.js');
      ResponsiveDrawerRef.current = mod.default || mod;
    }
  }

  // carrega o DrawerComparacao sob demanda
  async function ensureDrawerComparacaoLoaded() {
    if (!DrawerComparacaoRef.current) {
      const mod = await import('./disparoComparacao.js');
      DrawerComparacaoRef.current = mod.default || mod;
    }
  }

  async function openPropose() {
    await ensureResponsiveDrawerLoaded();
    setOpenResponsiveDrawer(true);
  }

  async function comparar() {
    await ensureDrawerComparacaoLoaded();
    setOpenDrawerComparacao(true);
  }

  // Abrir via PubSub (mantém sua API): PubSub.publish('openModalDisparo')
  useEffect(() => {
    const token = PubSub.subscribe('openModalDisparo', () => openPropose());
    return () => PubSub.unsubscribe(token);
  }, []);

  function logout() {
    if (props.deauthenticate) {
      props.deauthenticate().finally(() => Router.push('/'));
    } else {
      Router.push('/');
    }
  }

  const handleRedirect = (url) => {
    Router.push({ pathname: url});
  }

  const ResponsiveDrawer = ResponsiveDrawerRef.current;
  const DrawerComparacao = DrawerComparacaoRef.current;

  return (
    <div className='gap-sm-5 bg-white border-top position-fixed start-0 end-0 bottom-0 h-auto py-2 d-flex align-items-end justify-content-between justify-content-sm-center'>
      <button style={{maxWidth: '90px'}} className="btn-sm col text-uppercase btn text-muted flex-column d-flex justify-content-center text-center align-items-center" type="button" onClick={() => handleRedirect('/')}>
        <HomeOutlinedIcon titleAccess="Home" sx={{ width: 24, height: 24 }} width={24} height={24} />
        <small className="d-flex align-items-end lh" style={{height: '15px'}}>home</small>
      </button>
      {isAuthenticated && <button style={{maxWidth: '90px'}} type="button" className="btn-sm col text-uppercase btn text-muted flex-column d-flex justify-content-center text-center align-items-center" onClick={() => PubSub.publish('openFormPayment')}>
        <p className="m-0 lh lead fs-4">{props?.user?.creditos || 0}</p>
        <small className="d-flex align-items-end lh" style={{height: '15px'}}>créditos</small>
      </button>}                

      <button style={{maxWidth: '90px'}} className="btn-sm col text-uppercase btn text-muted flex-column d-flex justify-content-center text-center align-items-center" type="button" onClick={openPropose}>
        <AddCircleIcon titleAccess="Contratar" sx={{ width: 24, height: 24 }} width={24} height={24} />
        <small className="d-flex align-items-end lh text-nowrap" style={{height: '15px'}}>{props?.disparos?.length > 0 ? props?.disparos?.length === 1 ? '1 diarista': `${props?.disparos?.length} diaristas` : 'contratar'}</small>
      </button>

      {props?.disparos?.length > 0 && <button style={{maxWidth: '90px'}} className="btn-sm col text-uppercase btn text-muted flex-column d-flex justify-content-center text-center align-items-center" type="button" onClick={comparar}>
        <StarHalfIcon titleAccess="Comparar" sx={{ width: 24, height: 24 }} width={24} height={24} className="text-danger" />
        <small className="d-flex align-items-end lh" style={{height: '15px'}}>comparar</small>
      </button>}

      {!isAuthenticated && <button style={{maxWidth: '90px'}} className="btn-sm col text-uppercase btn text-muted flex-column d-flex justify-content-center text-center align-items-center" type="button" onClick={() => handleRedirect('/signin')}>
        <AccountCircleOutlinedIcon titleAccess="Login" sx={{ width: 24, height: 24 }} width={24} height={24} />
        <small className="d-flex align-items-end lh" style={{height: '15px'}}>login</small>
      </button>}

      {isAuthenticated && <Link style={{maxWidth: '90px'}} href="/signin" prefetch={false} className="btn-sm col text-uppercase btn text-muted flex-column d-flex justify-content-center text-center align-items-center">
        {(user && user.imageURL) && <>
            <img alt="Painel do usuário" style={{filter: 'grayscale(1)'}} alt={user.nome} width='24' height="24" className="image-perfil rounded-circle d-block" src={props?.user?.imageURL} />
            <small className="d-flex align-items-end lh" style={{height: '15px'}}>painel</small></>
        }
      </Link>}
      {isAuthenticated && <button style={{maxWidth: '90px'}} type="button" className="btn-sm col text-uppercase btn text-muted flex-column d-flex justify-content-center text-center align-items-center" onClick={logout}>
        <ExitToAppIcon titleAccess="Sair" sx={{ width: 24, height: 24 }} width={24} height={24}  />
        <small className="d-flex align-items-end lh" style={{height: '15px'}}>sair</small>
      </button>}                
 
      {ResponsiveDrawer && openResponsiveDrawer && (
        <ResponsiveDrawer
          {...props}
          open={openResponsiveDrawer}
          onClose={() => setOpenResponsiveDrawer(false)}
        />
      )}

      {DrawerComparacao && openDrawerComparacao && (
        <DrawerComparacao
          {...props}
          open={openDrawerComparacao}
          onClose={() => setOpenDrawerComparacao(false)}
        />
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
    isAuthenticated: !!state.authentication.token,
    token: state.authentication.token,
    user: state.authentication.user,
    disparos: state?.authentication?.disparos || []
  }
);

export default connect(mapStateToProps, actions)(DisparoShell);